module.exports = __webpack_public_path__ + "static/img/help3.db7154b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/help3.png
// module id = chhy
// module chunks = 1